import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./HandleBreakdown.css";

const HandleBreakdown = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    breakdow_status: "",
    date_resolved: "",
    resolved: "N",
  });
  const [originalResolved, setOriginalResolved] = useState("N");
  const [journeyPlaneNo, setJourneyPlaneNo] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const getCurrentLocalDateTime = (dateString) => {
    const localDate = new Date(dateString);
    if (isNaN(localDate.getTime())) return "";
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, "0");
    const day = String(localDate.getDate()).padStart(2, "0");
    const hours = String(localDate.getHours()).padStart(2, "0");
    const minutes = String(localDate.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const convertToUTC = (localDateTime) => {
    const date = new Date(localDateTime);
    if (isNaN(date.getTime())) {
      console.error("Invalid date value:", localDateTime);
      return null;
    }
    return date.toISOString();
  };

  useEffect(() => {
    fetchBreakdownRecord();
  }, [id]);

  const fetchBreakdownRecord = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/breakdownRecords/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      let rec = response.data;
      if (Array.isArray(rec)) rec = rec[0] || {};
      if (rec && rec.data) rec = rec.data;

      const norm = {};
      Object.keys(rec || {}).forEach((k) => (norm[k.toLowerCase()] = rec[k]));

      setFormData({
        breakdow_status: norm.breakdow_status || "",
        date_resolved: norm.date_resolved
          ? getCurrentLocalDateTime(norm.date_resolved)
          : "",
        resolved: norm.resolved || "N",
      });
      setOriginalResolved(norm.resolved || "N");
      setJourneyPlaneNo(norm.journey_plane_no || "");
    } catch (error) {
      console.error("Error fetching breakdown record:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked ? "Y" : "N" });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if already resolved
    if (originalResolved === "Y") {
      setMessage("This breakdown is already resolved and cannot be modified.");
      setTimeout(() => setMessage(""), 10000);
      return;
    }

    try {
      const token = localStorage.getItem("token");

      // Prepare data to submit
      const dataToSubmit = {
        resolved: formData.resolved,
      };
      if (formData.date_resolved) {
        dataToSubmit.date_resolved = convertToUTC(formData.date_resolved);
      }
      if (formData.breakdow_status) {
        dataToSubmit.breakdow_status = formData.breakdow_status;
      }

      await axios.patch(
        `${process.env.REACT_APP_BASE_API_URL}/breakdownRecords/${id}/handle`,
        dataToSubmit,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setMessage("Breakdown record handled successfully!");
      setTimeout(() => setMessage(""), 10000);
      navigate("/breakdown-tracker");
    } catch (error) {
      console.error("Error handling breakdown record:", error);
      setMessage("Failed to handle breakdown record.");
      setTimeout(() => setMessage(""), 10000);
    }
  };

  return (
    <div className="handle-breakdown-container">
      <button className="close-button" onClick={() => navigate("/breakdown-tracker")}>×</button>
      {message && <div className="message">{message}</div>}{" "}
      {/* Display message */}
      <h1 className="handle-breakdown-title">Handle Breakdown</h1>
      <div className="journey-plane-info">
        <strong>Journey No:</strong> {journeyPlaneNo}{" "}
      </div>
      <form onSubmit={handleSubmit} className="handle-breakdown-form">
        <div className="form-group">
          <label className="form-label">Breakdown Status:</label>{" "}
          <textarea
            name="breakdow_status"
            value={formData.breakdow_status}
            onChange={handleChange}
            className="form-textarea"
          />
        </div>
        <div className="form-row">
          <div className="form-group checkbox-group">
            <label className="form-label-checkbox">
              <input
                type="checkbox"
                name="resolved"
                checked={formData.resolved === "Y"}
                onChange={handleChange}
                className="form-checkbox"
              />
              Resolved
            </label>
          </div>
          {formData.resolved === "Y" && (
            <div className="form-group date-group">
              <label className="form-label">Date Resolved:</label>
              <input
                type="datetime-local"
                name="date_resolved"
                value={formData.date_resolved}
                onChange={handleChange}
                className="form-input"
                required
              />
            </div>
          )}
        </div>
        <div className="form-buttons">
          <button
            type="submit"
            className="btn btn-save"
            disabled={originalResolved === "Y"}
            title={
              originalResolved === "Y"
                ? "This breakdown is already resolved"
                : ""
            }
          >
            Save
          </button>
          <button
            type="button"
            className="btn btn-cancel"
            onClick={() => navigate("/breakdown-tracker")}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default HandleBreakdown;
